import { render, staticRenderFns } from "./section-content.vue?vue&type=template&id=d94baac2&scoped=true"
import script from "./section-content.vue?vue&type=script&lang=js"
export * from "./section-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94baac2",
  null
  
)

export default component.exports